<tabs (tabClicked)="onTabClicked($event)">
  <tab title="General Details">
    <div class="container grid-x">
      @if (!enableFullEditor) {
        <div class="small-12">
          <h3 class="h4 no-margin-bottom margin-top bold">General Information</h3>
        </div>
        <div class="cell small-12 medium-4">
          <div><label class="inline">API #:</label><span>{{well?.id}}</span></div>
          <div class="inline">
            <label class="inline">Lease Name:</label><span>{{leaseName}}</span>
          </div>
          <div><label class="inline">Owner Name:</label><span>{{well?.organizationName}}</span></div>
          <div><label class="inline">Well Symbol:</label><span>{{well?.mapSymbol}}</span></div>
          <div><label class="inline">Unit Acres:</label><span>{{well?.acresInDrillingUnit}}</span></div>
          <div><label class="inline">Rig Type:</label><span>{{well?.rigType}}</span></div>
          <!-- <div><label class="inline">Urban:</label><span>{{boolToYesNo(well?.location?.isUrban)}}</span></div> -->
          <div><label class="inline">Permitted Urban:</label><span>{{boolToYesNo(isPermittedUrban)}}</span></div>
          <div><label class="inline">Associated Financial Instrument Number:</label><span>{{wellFinancialInstrumentNumber}}</span></div>
        </div>
        <div class="cell small-12 medium-4">
          <div><label class="inline">Well Slant:</label><span>{{well?.location?.slant}}</span></div>
          <div><label class="inline">Original Owner:</label><span>{{well?.originalOwnerName}}</span></div>
          <div><label class="inline">Well Name:</label><span>{{well?.name}}</span></div>
          <div><label class="inline">Well #:</label><span>{{well?.wellNumber}}</span></div>
          <div><label class="inline">Well Class:</label><span>{{well?.odnrCurrentClass}}</span></div>
          <!--<div><label class="inline">Owner Well #:</label><span>{{well?.organizationsWellNumber}}</span></div>-->
          <div><label class="inline">Map Symbol:</label><span>{{well?.mapSym}}</span></div>
        </div>
        <div class="cell small-12 medium-4">
          <div><label class="inline">Issued:</label><span>{{well?.constructionPermit?.dateApproved | date: 'longDate':'+0000'}}</span></div>
          <div><label class="inline">Spud:</label><span>{{well?.dateWellDrillingStarted | date: 'longDate':'+0000'}}</span></div>
          <div><label class="inline">Put Into Production:</label><span>{{well?.production?.dateOfFirstProduction | date: 'longDate':'+0000'}}</span></div>
          <div><label class="inline">Total Depth Reached:</label><span>{{well?.dateTotalDepthReached | date: 'longDate':'+0000'}}</span></div>
          <div><label class="inline">Plugging Plan Approved:</label><span>{{well?.plugging?.datePluggingPlanApproved | date: 'longDate':'+0000'}}</span></div>
          <div><label class="inline">Plugged And Abandoned:</label><span>{{well?.plugging?.datePluggedAndAbandoned | date: 'longDate':'+0000'}}</span></div>
          <div><label class="inline">Vaulted / Vented:</label><span>{{boolToYesNo(well?.vaultedVented)}}</span></div>
          <div><label class="inline">Plug Back:</label><span>{{well?.plugging?.dateOfPlugBack | date: 'longDate':'+0000'}}</span></div>
        </div>
        <div class="small-12">
          <h3 class="h4 no-margin-bottom margin-top bold">Well Type and Disposition</h3>
        </div>
        <div class="cell small-12 medium-6">
          <div><label class="inline">Well Disposition:</label><span>{{wellDisposition}}</span></div>
          @if (displayWellDispositionLegacyTracking) {
            <div>
              <label class="inline">Well Disposition Legacy Tracking:</label>
              @if (canEditWellDispositionLegacyTracking && _wellDispositionLegacyTrackingDomainId) {
                <div class="padding-right">
                  <select (change)="setStatusDispositionLegacyTracking($event.target.value)">
                    @for (legacyTracking of wellDispositionLegacyTrackingDomainValues; track legacyTracking) {
                      <option [selected]="well.wellStatus.legacyTracking == legacyTracking.Code" [value]="legacyTracking.Code">{{legacyTracking.Definition}}</option>
                    }
                  </select>
                </div>
              }
              @if (!canEditWellDispositionLegacyTracking || (well?.wellStatus?.legacyTracking && !_wellDispositionLegacyTrackingDomainId)) {
                <div>
                  <span>{{wellDispositionLegacyTracking}}</span>
                </div>
              }
            </div>
          }
        </div>
        <div class="cell small-12 medium-6">
          <div>
            <div><label class="inline">Well Type:</label><span>{{wellType}}</span></div>
            @if (displayWellTypeDescription) {
              <div>
                <label class="inline">Well Type Description:</label>
                @if (canEditWellTypeDescription && _wellTypeDescriptionDomainId) {
                  <div>
                    <select (change)="setStatusTypeDescription($event.target.value)">
                      @for (description of wellTypeDescriptionDomainValues; track description) {
                        <option [selected]="well.wellStatus.type.description == description.Code" [value]="description.Code">{{description.Definition}}</option>
                      }
                    </select>
                  </div>
                }
                @if (!canEditWellTypeDescription || (well?.wellStatus?.type?.description && !_wellTypeDescriptionDomainId)) {
                  <div>
                    <span>{{wellTypeDescription}}</span>
                  </div>
                }
              </div>
            }
            @if (canEditWellTypeDescription && displayDomesticCheckboxes) {
              <div class="flex-align-center">
                <label class="vertical-align-middle minor-margin-right" for="hasOver5AcresControl">Have 5 or More Acres:</label>
                <input class="no-margin-bottom vertical-align-middle" name="hasOver5Acres" id="hasOver5AcresControl" type="checkbox" [checked]="!isWithout5Acres" [disabled]="!allowSwitchToggling"
                  (click)="toggleIsWithout5Acres()" />
                </div>
              }
              @if (canEditWellTypeDescription && displayDomesticCheckboxes) {
                <div class="flex-align-center padding-top">
                  <label class="vertical-align-middle minor-margin-right" for="hasReleaseOfLeaseControl">Have Release of Lease:</label>
                  <input class="no-margin-bottom vertical-align-middle" name="hasReleaseOfLease" id="hasReleaseOfLeaseControl" type="checkbox" [checked]="hasReleaseOfLease" [disabled]="!allowSwitchToggling"
                    (click)="toggleReleaseOfLease()" />
                  </div>
                }
              </div>
            </div>
            <div class="small-12">
              <h3 class="h4 no-margin-bottom margin-top bold">Depth and Formation</h3>
            </div>
            <div class="cell small-12 medium-3">
              <div><label class="inline">Ground Elev:</label><span>{{well?.location?.elevation?.groundLevel}}</span></div>
              <div><label class="inline">DTD:</label><span>{{well?.depths?.drillersMeasuredVerticalDepth}}</span></div>
            </div>
            <div class="cell small-12 medium-3">
              <div><label class="inline">Target Elev:</label><span>{{well?.location?.elevation?.target}}</span></div>
              <div><label class="inline">Kick Off TVD:</label><span>{{well?.depths?.kickoffTrueVerticalDepth}}</span></div>
            </div>
            <div class="cell small-12 medium-3">
              <div><label class="inline">DEM Elev:</label><span>{{well?.location?.elevation?.digitalElevationModel}}</span></div>
              <div><label class="inline">Plug Back TVD:</label><span>{{well?.depths?.plugbackMeasuredDepth}}</span></div>
            </div>
            <div class="cell small-12 medium-3">
              <div><label class="inline">LTD:</label><span>{{well?.depths?.loggerMeasuredVerticalDepth}}</span></div>
              <div><label class="inline">TVD:</label><span>{{well?.depths?.trueVerticalDepth}}</span></div>
            </div>
            <div class="cell small-12 medium-3">
              <div><label class="inline">Production Formation:</label><span>{{well?.proposedFormation}}</span></div>
            </div>
            <div class="cell small-12 medium-3">
              <div><label class="inline">AAPG Basin Code:</label>{{well?.aapgBasinCode}}</div>
            </div>
          } @else {
            <div class="small-12">
              <h3 class="h4 no-margin-bottom margin-top bold">General Information</h3>
              <span class="shrink-font">An <svg-icon class="tiny" icon="icon-notepad"></svg-icon> icon indicates a field is editable.  An <svg-icon class="tiny" icon="icon-notepad-alert"></svg-icon> icon indicates a field is editable and has unsaved changes.  Click on either icon to edit the field.</span>
            </div>
            <div class="cell small-12 medium-4 large-4">
              <div><label class="inline">API #:</label><span>{{well?.id}}</span></div>
              <div class="inline">
                <label class="inline">Lease Name:</label><span>{{editorForm?.get('lease')?.get('leaseName')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('lease')" [icon]="getEditIcon('lease')"></svg-icon></span>
              </div>
              <div><label class="inline">Owner Name:</label><span>{{well?.organizationName}}</span></div>
              <div><label class="inline">Well Symbol:</label><span>{{editorForm?.get('wellSymbol')?.get('wellSymbol')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('wellSymbol')" [icon]="getEditIcon('wellSymbol')"></svg-icon></span></div>
              <div><label class="inline">Unit Acres:</label><span>{{editorForm?.get('acresInDrillingUnit')?.get('acresInDrillingUnit')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('acresInDrillingUnit')" [icon]="getEditIcon('acresInDrillingUnit')"></svg-icon></span></div>
              <div><label class="inline">Rig Type:</label><span>{{editorForm?.get('rigType')?.get('rigType')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('rigType')" [icon]="getEditIcon('rigType')"></svg-icon></span></div>
              <!-- <div><label class="inline">Urban:</label><span>{{boolToYesNo(well?.location?.isUrban)}}</span></div> -->
              <div><label class="inline">Permitted Urban:</label><span>{{boolToYesNo(isPermittedUrban)}}</span></div>
              <div><label class="inline">Associated Financial Instrument Number:</label><span>{{wellFinancialInstrumentNumber}}</span></div>
            </div>
            <div class="cell small-12 medium-4 large-4">
              <div><label class="inline">Well Slant:</label><span>{{well?.location?.slant}}</span></div>
              <div><label class="inline">Original Owner:</label><span>{{well?.originalOwnerName}}</span></div>
              <div><label class="inline">Well Name:</label><span>{{editorForm?.get('wellName')?.get('wellName')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('wellName')" [icon]="getEditIcon('wellName')"></svg-icon></span></div>
              <div><label class="inline">Well #:</label><span>{{editorForm?.get('wellNumber')?.get('wellNumber')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('wellNumber')" [icon]="getEditIcon('wellNumber')"></svg-icon></span></div>
              <div><label class="inline">Well Class:</label><span>{{editorForm?.get('wellClass')?.get('wellClass')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('wellClass')" [icon]="getEditIcon('wellClass')"></svg-icon></span></div>
              <!--<div><label class="inline">Owner Well #:</label><span>{{well?.organizationsWellNumber}}</span></div>-->
              <div><label class="inline">Map Symbol:</label><span>{{editorForm?.get('mapSymbol')?.get('mapSymbol')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('mapSymbol')" [icon]="getEditIcon('mapSymbol')"></svg-icon></span></div>
            </div>
            <div class="cell small-12 medium-4 large-4">
              <div><label class="inline">Issued:</label><span>{{editorForm?.get('dateIssued')?.get('dateIssued')?.value| date: 'longDate':'+0000'}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('dateIssued')" [icon]="getEditIcon('dateIssued')"></svg-icon></span></div>
              <div><label class="inline">Spud:</label><span>{{editorForm?.get('spudDate')?.get('spudDate')?.value| date: 'longDate':'+0000'}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('spudDate')" [icon]="getEditIcon('spudDate')"></svg-icon></span></div>
              <div><label class="inline">Put Into Production:</label><span>{{editorForm?.get('dateOfFirstProduction')?.get('dateOfFirstProduction')?.value| date: 'longDate':'+0000'}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('dateOfFirstProduction')" [icon]="getEditIcon('dateOfFirstProduction')"></svg-icon></span></div>
              <div><label class="inline">Total Depth Reached:</label><span>{{editorForm?.get('dateTotalDepthReached')?.get('dateTotalDepthReached')?.value| date: 'longDate':'+0000'}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('dateTotalDepthReached')" [icon]="getEditIcon('dateTotalDepthReached')"></svg-icon></span></div>
              <div><label class="inline">Plugging Plan Approved:</label><span>{{editorForm?.get('datePluggingApproved')?.get('datePluggingApproved')?.value | date: 'longDate':'+0000'}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('datePluggingApproved')" [icon]="getEditIcon('datePluggingApproved')"></svg-icon></span></div>
              <div><label class="inline">Plugged And Abandoned:</label><span>{{editorForm?.get('datePluggedAndAbandoned')?.get('datePluggedAndAbandoned')?.value | date: 'longDate':'+0000'}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('datePluggedAndAbandoned')" [icon]="getEditIcon('datePluggedAndAbandoned')"></svg-icon></span></div>
              <div><label class="inline">Vaulted / Vented:</label><span>{{boolToYesNo(editorForm?.get('vaultedVented')?.get('vaultedVented')?.value)}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('vaultedVented')" [icon]="getEditIcon('vaultedVented')"></svg-icon></span></div>
              <div><label class="inline">Plug Back:</label><span>{{editorForm?.get('dateOfPlugBack')?.get('dateOfPlugBack')?.value | date: 'longDate':'+0000'}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('dateOfPlugBack')" [icon]="getEditIcon('dateOfPlugBack')"></svg-icon></span></div>
            </div>
            <div class="small-12 large-12 medium-12">
              <h3 class="h4 no-margin-bottom margin-top bold">Well Type and Disposition</h3>
            </div>
            <div class="small-12 large-6 medium-6">
              <div><label class="inline">Well Disposition:</label><span>{{wellDisposition}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('disposition')" [icon]="getEditIcon('disposition', 'disposition')"></svg-icon></span></div>
              @if (displayWellDispositionLegacyTracking) {
                <div>
                  <label class="inline">Well Disposition Legacy Tracking:</label><span>{{legacyTracking}}</span><span class="padding-left">@if (canEditWellDispositionLegacyTracking) {
                  <svg-icon class="tiny" (click)="openEditor('disposition')" [icon]="getEditIcon('disposition', 'legacyTracking')"></svg-icon>
                }</span>
              </div>
            }
          </div>
          <div class="small=12 medium-6 large-6">
            <div><label class="inline">Well Type@if (editorForm?.get('wellType')?.dirty) {
              <span class="padding-left"><help-text [helpText]="infoBubble" [alert]="true"></help-text></span>
              }: </label><span>{{wellStatusType}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('wellType')" [icon]="getEditIcon('wellType', 'wellType')"></svg-icon></span></div>
              @if (canEditWellTypeDescription) {
                <div>
                  <label class="inline">Well Type Description:</label><span>{{wellStatusTypeDescription}}</span><span class="padding-left">@if (canEditWellTypeDescription) {
                  <svg-icon class="tiny" (click)="openEditor('wellType')" [icon]="getEditIcon('wellType', 'wellTypeDescription')"></svg-icon>
                }</span>
                @if (displayDomesticCheckboxes) {
                  <div>
                    <label class="vertical-align-middle minor-margin-right" for="hasOver5AcresControl">Have Over 5 Acres:</label>
                    <input class="no-margin-bottom vertical-align-middle" name="hasOver5Acres" id="hasOver5AcresControl" type="checkbox" [checked]="has5Acres" [disabled]="true" />
                    <span class="padding-left">@if (canEditWellTypeDescription && allowSwitchToggling) {
                      <svg-icon class="tiny" (click)="openEditor('wellType')" [icon]="getEditIcon('wellType', 'has5Acres')"></svg-icon>
                    }</span>
                  </div>
                  <div>
                    <label class="vertical-align-middle minor-margin-right" for="hasReleaseOfLeaseControl">Have Release of Lease:</label>
                    <input class="no-margin-bottom vertical-align-middle" name="hasReleaseOfLease" id="hasReleaseOfLeaseControl" type="checkbox" [checked]="releaseOfLease" [disabled]="true" />
                    <span class="padding-left">@if (canEditWellTypeDescription && allowSwitchToggling) {
                      <svg-icon class="tiny" (click)="openEditor('wellType')" [icon]="getEditIcon('wellType', 'hasReleaseOfLease')"></svg-icon>
                    }</span>
                  </div>
                }
              </div>
            }
          </div>
          <div class="large -12 small-12 medium-12">
            <h3 class="h4 no-margin-bottom margin-top bold">Depth and Formation</h3>
          </div>
          <div class="cell small-12 medium-3 large-3">
            <div><label class="inline">Ground Elev:</label><span>{{editorForm?.get('groundElevation')?.get('groundElevation')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('groundElevation')" [icon]="getEditIcon('groundElevation')"></svg-icon></span></div>
            <div><label class="inline">DTD:</label><span>{{editorForm?.get('dtd')?.get('dtd')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('dtd')" [icon]="getEditIcon('dtd')"></svg-icon></span></div>
          </div>
          <div class="cell small-12 medium-3 large-3">
            <div><label class="inline">Target Elev:</label><span>{{editorForm?.get('targetElevation')?.get('targetElevation')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('targetElevation')" [icon]="getEditIcon('targetElevation')"></svg-icon></span></div>
            <div><label class="inline">Kick Off TVD:</label><span>{{editorForm?.get('kickoff')?.get('kickoff')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('kickoff')" [icon]="getEditIcon('kickoff')"></svg-icon></span></div>
          </div>
          <div class="cell small-12 medium-3 large-3">
            <div><label class="inline">DEM Elev:</label><span>{{editorForm?.get('digitalElevationModel')?.get('digitalElevationModel')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('digitalElevationModel')" [icon]="getEditIcon('digitalElevationModel')"></svg-icon></span></div>
            <div><label class="inline">Plug Back TVD:</label><span>{{editorForm?.get('plugbackDepth')?.get('plugbackDepth')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('plugbackDepth')" [icon]="getEditIcon('plugbackDepth')"></svg-icon></span></div>
          </div>
          <div class="cell small-12 medium-3 large-3">
            <div><label class="inline">LTD:</label><span>{{editorForm?.get('loggersDepth')?.get('loggersDepth')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('loggersDepth')" [icon]="getEditIcon('loggersDepth')"></svg-icon></span></div>
            <div><label class="inline">TVD:</label><span>{{editorForm?.get('trueVerticalDepth')?.get('trueVerticalDepth')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('trueVerticalDepth')" [icon]="getEditIcon('trueVerticalDepth')"></svg-icon></span></div>
          </div>
          <div class="cell small-12 medium-3 large-3">
            <div><label class="inline">Production Formation:</label><span>{{editorForm?.get('proposedFormation')?.get('proposedFormation')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('proposedFormation')" [icon]="getEditIcon('proposedFormation')"></svg-icon></span></div>
          </div>
          <div class="cell small-12 medium-3 large-3">
            <div><label class="inline">AAPG Basin Code:</label><span>{{editorForm?.get('aapgBasinCode')?.get('aapgBasinCode')?.value}}</span><span class="padding-left"><svg-icon class="tiny" (click)="openEditor('aapgBasinCode')" [icon]="getEditIcon('aapgBasinCode')"></svg-icon></span></div>
          </div>
        }

      </div>
      <landowner-passthrough-details [apiNumber]="well?.id"></landowner-passthrough-details>
      @if (well?.wellStatus?.type?.type == 'ST_R') {
        <stratigraphic-well-bonding [activeBondingRequirement]="well?.activeBondingRequirement" [api]="well?.id" [bondingRequirementHistory]="well?.bondingRequirements" (bondingUpdated)="onBondingUpdated($event)"></stratigraphic-well-bonding>
      }
      <div class="small-12">
        <h3 class="h4 no-margin-bottom margin-top bold">Well Transfer History</h3>
      </div>
      <ag-grid-angular class="data-grid " [rowData]="well?.ownerHistory" [gridOptions]="gridOptions" aria-label="General Details"></ag-grid-angular>
    </tab>

    <tab title="Location Details">
      <div class="container grid-x">
        @if (!enableFullEditor) {
          <div class="small-4">
            <h3 class="h4 no-margin-bottom margin-top bold">Source of Location</h3>
            {{sourceOfLocation}}
          </div>
          @for (wellPoint of well?.location?.gisPoints; track wellPoint) {
            <div class="small-12">
              <h3 class="h4 no-margin-bottom margin-top bold">{{pointTypeFormatter(wellPoint.pointType)}} Location</h3>
            </div>
            <div class="cell small-12 medium-3">
              <div><label class="inline">County API Number:</label><span>{{wellPoint?.county?.apiNumber}}</span></div>
              <div><label class="inline">County Name:</label><span>{{wellPoint?.county?.name}}</span></div>
            </div>
            <div class="cell small-12 medium-3">
              <div><label class="inline">Township:</label><span>{{wellPoint?.township?.name}}</span></div>
              <div><label class="inline">NSEW:</label><span>{{wellPoint?.coordinates?.statePlaneZone}}</span></div>
            </div>
            <div class="cell small-12 medium-3">
              <div><label class="inline">Quadrangle:</label>
              <<span>
              {{	getQuadrangleDisplay(wellPoint)   }}
            </span>
          </div>
          <div><label class="inline">Lot:</label><span>{{wellPoint?.lot}}</span></div>
        </div>
        <div class="cell small-12 medium-3">
          <div><label class="inline">Quarter TWP:</label><span>{{wellPoint?.quarterTownship}}</span></div>
          <div><label class="inline">Fraction:</label><span>{{wellPoint?.fraction}}</span></div>
        </div>
        <div class="cell small-12 medium-3">
          <div><label class="inline">Section:</label><span>{{wellPoint?.section}}</span></div>
        </div>
        <div class="cell small-12 medium-3">
          <div><label class="inline">Allotment:</label><span>{{wellPoint?.allotment}}</span></div>
        </div>
        <div class="cell small-12 medium-3">
          <div><label class="inline">Tract:</label><span>{{wellPoint?.tract}}</span></div>
        </div>
        <div class="cell small-12">
          <div><label class="inline">Footage:</label><span>{{wellPoint?.footageCallsFromSectionLines}}</span></div>
        </div>
        <div class="cell small-12 medium-6">
          <div><label class="inline">SP-X (NAD27):</label><span>{{wellPoint?.coordinates?.statePlaneXCoordinate}}</span></div>
          <div><label class="inline">SP-Y (NAD27):</label><span>{{wellPoint?.coordinates?.statePlaneYCoordinate}}</span></div>
        </div>
        <div class="cell small-12 medium-6">
          <div><label class="inline">SP-X (NAD83):</label><span>{{wellPoint?.coordinates?.nad83XCoordinate}}</span></div>
          <div><label class="inline">SP-Y (NAD83):</label><span>{{wellPoint?.coordinates?.nad83YCoordinate}}</span></div>
        </div>
        <div class="cell small-12 medium-6">
          <div><label class="inline">Long (NAD27):</label><span>{{wellPoint?.coordinates?.longitude | number:'1.0-6'}}</span></div>
          <div><label class="inline">Lat (NAD27):</label><span>{{wellPoint?.coordinates?.latitude | number:'1.0-6'}}</span></div>
        </div>
        <div class="cell small-12 medium-6">
          <div><label class="inline">Long (NAD83):</label><span>{{wellPoint?.coordinates?.longitude83 | number:'1.0-6'}}</span></div>
          <div><label class="inline">Lat (NAD83):</label><span>{{wellPoint?.coordinates?.latitude83 | number:'1.0-6' }}</span></div>
        </div>
      }
    } @else {
      <div class="small-12 medium-12 large-12">
        <span class="shrink-font">An <svg-icon class="tiny" icon="icon-notepad"></svg-icon> icon indicates a field is editable.  An <svg-icon class="tiny" icon="icon-notepad-alert"></svg-icon> icon indicates a field is editable and has unsaved changes.  Click on either icon to edit the field.</span><br />
        <span class="shrink-font">Only the Latitude (NAD83) and Longitude (NAD83) values of each point are directly editable.  Remaining fields will be updated via GIS queries upon changes to either of those fields.</span>
      </div>
      <div class="small-12 medium-12 large-12">
        <h3 class="h4 no-margin-bottom margin-top bold">Source of Location</h3>
      </div>
      <div class="small-12 medium-12 large-12">
        {{sourceOfLocation}}<span class="padding-left"><svg-icon class="tiny" (click)="openEditor('location')" [icon]="getEditIcon('location')"></svg-icon></span>
      </div>
      @for (point of validPointTypes; track point) {
        <div class="small-12 medium-12 small-12">
          <h3 class="h4 no-margin-bottom margin-top bold">{{pointTypeFormatter(point)}} Location @if (pointExists(point) == false) {
            <svg-icon class="tiny" icon="icon-plus" (click)="addPoint(point)"></svg-icon>
            }@if (pointExists(point) == true) {
            <svg-icon class="tiny" (click)="openEditor(point)" [icon]="getEditIcon(point)"></svg-icon>
          }</h3>
        </div>
        @if (pointExists(point)) {
          <div class="cell small-12 medium-3 large-3">
            <div><label class="inline">County API Number:</label><span>{{getPointValueFromForm(point, 'county|apiNumber')}}</span></div>
            <div><label class="inline">County Name:</label><span>{{getPointValueFromForm(point, 'county|name')}}</span></div>
          </div>
          <div class="cell small-12 medium-3">
            <div><label class="inline">Township:</label><span>{{getPointValueFromForm(point, 'township|name')}}</span></div>
            <div><label class="inline">NSEW:</label><span>{{getPointValueFromForm(point, 'coordinates|statePlaneZone')}}</span></div>
          </div>
          <div class="cell small-12 medium-3">
            <div><label class="inline">Quadrangle:</label><span>{{getQuadrangleDisplayForForm(point)}}</span></div>
            <div><label class="inline">Lot:</label><span>{{getPointValueFromForm(point, 'lot')}}</span></div>
          </div>
          <div class="cell small-12 medium-3">
            <div><label class="inline">Quarter TWP:</label><span>{{getPointValueFromForm(point, 'quarterTownship')}}</span></div>
            <div><label class="inline">Fraction:</label><span>{{getPointValueFromForm(point, 'fraction')}}</span></div>
          </div>
          <div class="cell small-12 medium-3">
            <div><label class="inline">Section:</label><span>{{getPointValueFromForm(point, 'section')}}</span></div>
          </div>
          <div class="cell small-12 medium-3">
            <div><label class="inline">Allotment:</label><span>{{getPointValueFromForm(point, 'allotment')}}</span></div>
          </div>
          <div class="cell small-12 medium-3">
            <div><label class="inline">Tract:</label><span>{{getPointValueFromForm(point, 'tract')}}</span></div>
          </div>
          <div class="cell small-12">
            <div><label class="inline">Footage:</label><span>{{getPointValueFromForm(point, 'footageCallsFromSectionLines')}}</span></div>
          </div>
          <div class="cell small-12 medium-6">
            <div><label class="inline">SP-X (NAD27):</label><span>{{getPointValueFromForm(point, 'coordinates|statePlaneXCoordinate')}}</span></div>
            <div><label class="inline">SP-Y (NAD27):</label><span>{{getPointValueFromForm(point, 'coordinates|statePlaneYCoordinate')}}</span></div>
          </div>
          <div class="cell small-12 medium-6">
            <div><label class="inline">SP-X (NAD83):</label><span>{{getPointValueFromForm(point, 'coordinates|nad83XCoordinate')}}</span></div>
            <div><label class="inline">SP-Y (NAD83):</label><span>{{getPointValueFromForm(point, 'coordinates|nad83YCoordinate')}}</span></div>
          </div>
          <div class="cell small-12 medium-6">
            <div><label class="inline">Long (NAD27):</label><span>{{getPointValueFromForm(point, 'coordinates|longitude') | number:'1.0-6'}}</span></div>
            <div><label class="inline">Lat (NAD27):</label><span>{{getPointValueFromForm(point, 'coordinates|latitude') | number:'1.0-6'}}</span></div>
          </div>
          <div class="cell small-12 medium-6">
            <div><label class="inline">Long (NAD83):</label><span>{{getPointValueFromForm(point, 'coordinates|longitude83') | number:'1.0-6'}}</span></div>
            <div><label class="inline">Lat (NAD83):</label><span>{{getPointValueFromForm(point, 'coordinates|latitude83') | number:'1.0-6' }}</span></div>
          </div>
        }
      }
    }

  </div>
</tab>

@if (well?.injection?.maxAllowableRate) {
  <tab title="UIC Details">
    <div class="container grid-x">
      <div class="cell small-12 medium-4">
        <div class="small-12">
          <h3 class="h4 no-margin-bottom margin-top bold">Compliance</h3>
        </div>
        <div><label class="inline">Is Compliant:</label><span>{{well?.compliance?.isCompliant}}</span></div>
        <div><label class="inline">Date Of Last Compliance Review:</label><span>{{well?.compliance?.dateOfLastReview}}</span></div>
      </div>
      <div class="cell small-12 medium-4">
        <div class="small-12">
          <h3 class="h4 no-margin-bottom margin-top bold">Allowables</h3>
        </div>
        <div><label class="inline">Max Allowable Pressure:</label><span>{{well?.injection?.maxAllowablePressure}}</span></div>
        <div><label class="inline">Max Allowable Rate:</label><span>{{well?.injection?.maxAllowableRate}}</span></div>
      </div>
      <div class="cell small-12 medium-12">
        <div class="small-12">
          <h3 class="h4 no-margin-bottom margin-top bold">Annulus Monitoring</h3>
        </div>
        <div><label class="inline">Date Approved:</label><span>{{well?.annulus?.datePressureMonitoringApproved | date}}</span></div>
        <div><label class="inline">Minimum Requirement:</label><span>{{well?.annulus?.minimumRequiredPressure}}</span></div>
        <div><label class="inline">Fluid:</label><span>{{well?.annulus?.typeOfFluid}}</span></div>
        <div><label class="inline">Specific Gravity of Fluid</label><span>{{well?.annulus?.specificGravityOfFluid}}</span></div>
      </div>
      <div class="cell small-12 medium-4">
        <div class="small-12">
          <h3 class="h4 no-margin-bottom margin-top bold">Water Analysis</h3>
        </div>
        <div><label class="inline">Date:</label><span>{{well?.dateOfWaterAnalysis | date}}</span></div>
        <div><label class="inline">Injection Fluid:</label><span>{{well?.injection?.typeOfFluid}}</span></div>
        <div><label class="inline">Specific Gravity Injection Fluid:</label><span>{{well?.injection?.specificGravityOfInjectate}}</span></div>
        <div><label class="inline">PH of Injection Fluid:</label><span>{{well?.injection?.phOfInjectate}}</span></div>
      </div>
      <div class="cell small-12 medium-4">
        <div class="small-12">
          <h3 class="h4 no-margin-bottom margin-top bold">Mechanical Integrity</h3>
        </div>
        <div>
          <label class="inline">External MIT Freq:</label>
          <span>{{well?.mechanicalIntegrity?.externalDemonstrationFrequency}}</span>
          <label class="inline">Next MIT due:</label>
          <span>{{well?.mechanicalIntegrity?.dateOfNextExternalDemonstration}}</span>
        </div>
        <div>
          <label class="inline">Internal MIT Freq:</label>
          <span>{{well?.mechanicalIntegrity?.internalDemonstrationFrequency}}</span>
          <label class="inline">Next MIT due:</label>
          <span>{{well?.mechanicalIntegrity?.dateOfNextInternalDemonstration}}</span>
        </div>
        <div><label class="inline">Mon. Freq:</label><span>{{well?.uicMonitoringReportFrequency}}</span></div>
        <div><label class="inline">IMIT Req Tst Press:</label><span>{{well?.mechanicalIntegrity?.internalTestRequestedPressure}}</span></div>
      </div>
    </div>
  </tab>
}

<tab title="Formations">
  @if (configLoaded) {
    <well-detail-casing-strings [well]="well" [canEdit]="enableFullEditor" (casingTubingUpdated)="updateCasingTubingRecord($event)"></well-detail-casing-strings>
    <well-detail-formations [well]="well" [canEdit]="enableFullEditor" (formationRecordEdited)="updateFormationRecord($event)"></well-detail-formations>
  }
</tab>

@if (canSeeDocuments) {
  <tab title="Well Documents">
    @if (viewDocuments) {
      <onbase-well-documents [apiNumber]="apiNumber"></onbase-well-documents>
    }
  </tab>
}
<tab title="Production Reporting">
  <production-reporting [apiNumber]="apiNumber"></production-reporting>
</tab>
@if (canSeeComplianceDates) {
  <tab title="Compliance Dates">
    <compliance-dates [well]="well" [canEdit]="canEditWellDetails"></compliance-dates>
  </tab>
}
</tabs>



